module.exports = __webpack_public_path__ + "static/Pianeta_new_ats_1-11e18cddccc762890f7debc71960d5df.svg";